import SourceDataNode from "./nodes/SourceDataNode";
import IntermediateNode from "./nodes/IntermediateNode";
import FinalNode from "./nodes/FinalNode";


export const CUSTOM_NODE_TYPES = {source: SourceDataNode, intermediate: IntermediateNode, final: FinalNode};
